import { AnyAction } from 'redux';
import { PayloadAction } from '@reduxjs/toolkit';

const defaultMapper = (item: any) => item;

export const fetchInitialState = {
  isLoading: false,
  isLoaded: false,
  errors: [],
  current: {},
};

export const updateInitialState = {
  isUpdating: false,
  isUpdated: false,
  errors: [],
  current: {},
};

export const createInitialState = {
  isCreating: false,
  isCreated: false,
  errors: [],
  current: {},
};

export const onFetchStart = (state: any) => ({
  ...state,
  isLoading: true,
  isLoaded: false,
  errors: [],
});

export const onFetchSuccessWithMapper =
  (mapper: any) =>
  (state: any, { payload }: any) => ({
    ...state,
    isLoading: false,
    isLoaded: true,
    current: mapper('data' in payload ? payload.data : payload),
  });

export const onFetchSuccess = onFetchSuccessWithMapper(defaultMapper);

export type PayloadError = {
  errors: string[];
};

export const onFetchError = (state: any, action: PayloadAction<PayloadError>) => ({
  ...state,
  errors: action.payload.errors,
  isLoading: false,
});

export const onUpdateStart = (state: any) => ({
  ...state,
  isUpdated: false,
  isUpdating: true,
  errors: [],
});

export const onUpdateError = (state: any, action: AnyAction) => ({
  ...state,
  isUpdated: false,
  isUpdating: false,
  errors: action.payload.errors,
});

export const onUpdateSuccessWithMapper =
  (mapper: any) =>
  (state: any, { payload }: any) => ({
    ...state,
    isUpdating: false,
    isUpdated: true,
    current: mapper('data' in payload ? payload.data : payload),
  });

export const onUpdateSuccess = onUpdateSuccessWithMapper(defaultMapper);

export const onCreateStart = (state: any) => ({
  ...state,
  isCreated: false,
  isCreating: true,
  errors: [],
});

export const onCreateError = (state: any, action: AnyAction) => ({
  ...state,
  isCreated: false,
  isCreating: false,
  errors: action.payload.errors,
  current: {},
});

export const onCreateSuccess = (state: any, action: AnyAction, mapper = defaultMapper) => ({
  ...state,
  isCreating: false,
  isCreated: true,
  current: mapper(action.payload.data ?? action.payload),
});
